import React from "react";


const SideBar = ({ movies }) => {
  return (
    <>
      <header>
        <div className="nav">
          <nav className="side-nav-container">
            <ul className="links">
              <h3 className="logo">Movie Mania</h3>

              <br />

              <h5>Categories</h5>
              <li>
                <div className="item-category">
                  <i className="ri-film-line"></i>
                  <h3>Popular</h3>
                </div>
              </li>
              <li>
                <div className="item-category">
                  <i className="ri-star-line"></i>
                  <h3>Top Rated</h3>
                </div>
              </li>
              <li>
                <div className="item-category">
                  <i className="ri-tv-2-line"></i>
                  <h3>Upcoming</h3>
                </div>
              </li>
            </ul>
            <br />
            <hr style={{ width: "100%" }} />
            <h5>Available Movies</h5>

            {movies.map((movie) => {
              const { id, title } = movie;
              return (
                <>
                  <section key={id}>
                    <div>
                      <div className="item" style={{ gap: ".7rem" }}>
                        <i className="ri-movie-fill"></i>
                        <h2>{title}</h2>
                      </div>
                    </div>
                  </section>
                </>
              );
            })}
          </nav>
        </div>
      </header>
    </>
  );
};

export default SideBar;
